/*
 *  Document   : client-mission-index.js
 *  Author     : Exapoint
 *
 */

// Import required modules

// Tools

import ExaHelpers from "../exa_helpers";

export default class ClientMissionIndex {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ClientMissionIndex"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {

        // Fix for incorrect body height
        document.querySelector('body').style.height = 'auto';

        this.$infoContainer = $('#mission-info-container');
        this.$missionCandidatesTable = $('#mission-candidates-table.js-dataTable-full-pagination');
        this.$activeMissionInfoContainer = $('#active-mission-info-container');
        this.$confirmedCandidatesTable = $('#confirmed-candidates-table.js-dataTable-full-pagination');
        this.$archivedMissionInfoContainer = $('#archived-mission-info-container');
        this.$archivedCandidatesTable = $('#archived-candidates-table.js-dataTable-full-pagination');

        this.$missionsTable = $('#mission-matching-candidates #missions-table').DataTable({
            ajax: jsVars.missionsDatatablesAjax,
            order: [[1, "asc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: "titre",
                    render: function (data, type, row) {
                        let notEditableInfo = '';
                        if (row.edits_count > jsVars.maximumMissionEditsCount) {
                            notEditableInfo = `<span class="ml-2 badge badge-pill badge-warning">${jsVars.notEditableText}</span>`;
                        }

                        return `${data? data : ''}`;
                    }
                },
                {
                    data: "professions",
                    render: function (data, type, row) {
                        let notEditableInfo = '';
                        if (row.edits_count > jsVars.maximumMissionEditsCount) {
                            notEditableInfo = `<span class="ml-2 badge badge-pill badge-warning">${jsVars.notEditableText}</span>`;
                        }

                        return `<a href="${jsVars.editMissionUrl.replace(':mission-id', row.id)}" class="font-w500 placeholder">${data}</a>${notEditableInfo}`;
                    }
                },
                {
                    data: "first_activation",
                    render: function (data, type, row) {

                        if(row.first_activation){
                            let first_activation = new Date(row.first_activation);

                            first_activation = ExaHelpers.isValidDate(first_activation) ? ExaHelpers.formatDateWithLocale(first_activation) : '';
                            return first_activation;
                        }else{
                            return "";
                        }
                    }
                },
                {
                    data: "start_date",
                    render: function (data, type, row) {
                        let startDate = new Date(row.start_date);
                        let endDate = new Date(row.end_date);

                        startDate = ExaHelpers.isValidDate(startDate) ? ExaHelpers.formatDateWithLocale(startDate) : '';
                        /*if (ExaHelpers.isValidDate(endDate)) {
                            if (endDate.getFullYear() === 9999) {
                                endDate = jsVars.no_end_date;
                            } else {
                                endDate = ExaHelpers.formatDateWithLocale(endDate);
                            }
                        } else {
                            endDate = '';
                        }*/

                        endDate = '';

                        return [startDate, endDate].filter(Boolean).join("<br>");
                    }
                },
                {
                    data: "created_by_user.full_name"
                },
                {
                    orderable: false,
                    data: null,
                    render: function (data, type, row) {
                        let html = '';
                        html += `<table class="table table-sm table-vcenter mb-0">`;
                        html += `<tr><td><a class="btn btn-table btn-tag primary">${jsVars.contactedCountText}<span class="badge badge-primary ml-2">${row.contactedCount}</span></a></td></tr>`;
                        if (row.acceptedCount) {
                            html += `<tr><td><a href="#" class="btn btn-table btn-tag success" onclick="ClientMissionIndex.showFilteredCandidates(${row.id}, 'accepted', this)">${jsVars.acceptedCountText}<span class="badge badge-success ml-2">${row.acceptedCount}</span></a></td></tr>`;
                        } else {
                            html += `<tr><td><span class="btn btn-table btn-tag success no-cursor">${jsVars.acceptedCountText}<span class="badge badge-success ml-2">${row.acceptedCount}</span></span></td></tr>`;
                        }
                        if (row.notifiedConfirmationCount) {
                            html += `<tr><td><a href="#" class="btn btn-table btn-tag success" onclick="ClientMissionIndex.showFilteredCandidates(${row.id}, 'notified', this)">${jsVars.notifiedConfirmationCountText}<span class="badge badge-success ml-2">${row.notifiedConfirmationCount}</span></a></td></tr>`;
                        } else {
                            html += `<tr><td><span class="btn btn-table btn-tag success no-cursor">${jsVars.notifiedConfirmationCountText}<span class="badge badge-success ml-2">${row.notifiedConfirmationCount}</span></span></td></tr>`;
                        }
                        if (row.confirmedCount) {
                            html += `<tr><td><a href="#" class="btn btn-table btn-tag success" onclick="ClientMissionIndex.showFilteredCandidates(${row.id}, 'confirmed', this)">${jsVars.confirmedCountText}<span class="badge badge-success ml-2">${row.confirmedCount}</span></a></td></tr>`;
                        }else{
                            html += `<tr><td><span class="btn btn-table btn-tag success no-cursor">${jsVars.confirmedCountText}<span class="badge badge-success ml-2">${row.confirmedCount}</span></span></td></tr>`;
                        }
                        html += `<tr><td><span class="btn btn-table btn-tag danger">${jsVars.declinedCountText}<span class="badge badge-danger ml-2">${row.declinedCount}</span></span></td></tr>`;
                        html += `</table>`;

                        html += `<div class="text-center"><a href="/app/${jsVars.languages}/client/missions/create/${row.id}" class="btn btn-primary btn-tag duplique btn-table"><i class="fa fa-fw fa-plus mr-1"></i>${jsVars.duplicateThisMission}</a></div>`;

                        return html;
                    }
                },
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true,
            initComplete: function () {
                if (!jsVars.hasCompany) return;
                let $container = $(this.api().table().container()).find('.dataTables_filter');
                $(`
                <a href="${jsVars.createMissionUrl}" class="btn btn-primary btn-reduce">
                    <i class="fa fa-fw fa-plus mr-1"></i>
                    ${jsVars.createNewMission}
                </a>
                `).prependTo($container);
            }
        });

        $('#active-missions #active-missions-table').DataTable({
            ajax: jsVars.activeMissionsDatatablesAjax,
            order: [[1, "asc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
             {
                    data: "titre",
                    render: function (data, type, row) {
                        let notEditableInfo = '';
                        if (row.edits_count > jsVars.maximumMissionEditsCount) {
                            notEditableInfo = `<span class="ml-2 badge badge-pill badge-warning">${jsVars.notEditableText}</span>`;
                        }

                        return `<a href="${jsVars.editMissionUrl.replace(':mission-id', row.id)}">${data? data : ''}</a>${notEditableInfo}`;
                    }
                },
                {
                    data: "professions",
                    render: function (data, type, row) {
                        return `<a href="${jsVars.editMissionUrl.replace(':mission-id', row.id)}">${data}</a>`;
                    }
                },
                {
                    data: "first_activation",
                    render: function (data, type, row) {

                        if(row.first_activation){
                            let first_activation = new Date(row.first_activation);

                            first_activation = ExaHelpers.isValidDate(first_activation) ? ExaHelpers.formatDateWithLocale(first_activation) : '';
                            return first_activation;
                        }else{
                            return "";
                        }
                    }
                },
                {
                    data: "start_date",
                    render: function (data, type, row) {
                        let startDate = new Date(row.start_date);
                        let endDate = new Date(row.end_date);

                        startDate = ExaHelpers.isValidDate(startDate) ? ExaHelpers.formatDateWithLocale(startDate) : '';
                        /*if (ExaHelpers.isValidDate(endDate)) {
                            if (endDate.getFullYear() === 9999) {
                                endDate = jsVars.noEndDate;
                            } else {
                                endDate = ExaHelpers.formatDateWithLocale(endDate);
                            }
                        } else {
                            endDate = '';
                        }*/
                        endDate = '';
                        return [startDate, endDate].filter(Boolean).join("<br>");
                    }
                },
                {
                    data: "created_by_user.full_name"
                },
                {
                    orderable: false,
                    data: null,
                    render: function (data, type, row) {
                        // return 123;
                        let html = '';
                        html += `<table class="table table-sm table-vcenter mb-0">`;
                        if (row.confirmedCount) {
                            html += `<tr><td><a href="#" class="btn btn-table btn-tag success" onclick="ClientMissionIndex.showConfirmedCandidates(${row.id}, 'confirmed', this)">${jsVars.confirmedCountText}<span class="badge badge-success">${row.confirmedCount}</span></a></td></tr>`;
                        }
                        html += `</table>`;

                        html += `<div class="text-center"><a href="/app/${jsVars.languages}/client/missions/create/${row.id}" class="btn btn-primary btn-tag duplique btn-table"><i class="fa fa-fw fa-plus mr-1"></i>${jsVars.duplicateThisMission}</a></div>`;

                        return html;
                    }
                },
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true,
            initComplete: function () {
                if (!jsVars.hasCompany) return;
                let $container = $(this.api().table().container()).find('.dataTables_filter');
                $(`
                <a href="${jsVars.createMissionUrl}" class="btn btn-primary btn-reduce">
                    <i class="fa fa-fw fa-plus mr-1"></i>
                    ${jsVars.createNewMission}
                </a>
                `).prependTo($container);
            }
        });

        ExaHelpers.validation();
        this.initValidation();

        $('#archived-missions #archived-missions-table').DataTable({
            ajax: jsVars.archivedMissionsDatatablesAjax,
            order: [[1, "desc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
             {
                    data: "titre",
                    render: function (data, type, row) {
                        let notEditableInfo = '';
                        if (row.edits_count > jsVars.maximumMissionEditsCount) {
                            notEditableInfo = `<span class="ml-2 badge badge-pill badge-warning">${jsVars.notEditableText}</span>`;
                        }

                        return `<a href="${jsVars.editMissionUrl.replace(':mission-id', row.id)}">${data? data : ''}</a>${notEditableInfo}`;
                    }
                },
                {
                    data: "professions",
                    render: function (data, type, row) {
                        return `<a href="${jsVars.editMissionUrl.replace(':mission-id', row.id)}">${data}</a>`;
                    }
                },
                {
                    data: "first_activation",
                    render: function (data, type, row) {

                        if(row.first_activation){
                            let first_activation = new Date(row.first_activation);

                            first_activation = ExaHelpers.isValidDate(first_activation) ? ExaHelpers.formatDateWithLocale(first_activation) : '';
                            return first_activation;
                        }else{
                            return "";
                        }
                    }
                },
                {
                    data: "start_date",
                    render: function (data, type, row) {
                        let startDate = new Date(row.start_date);
                        let endDate = new Date(row.end_date);

                        startDate = ExaHelpers.isValidDate(startDate) ? ExaHelpers.formatDateWithLocale(startDate) : '';
                        /*if (ExaHelpers.isValidDate(endDate)) {
                            if (endDate.getFullYear() === 9999) {
                                endDate = jsVars.no_end_date;
                            } else {
                                endDate = ExaHelpers.formatDateWithLocale(endDate);
                            }
                        } else {
                            endDate = '';
                        }*/
                        endDate = '';
                        return [startDate, endDate].filter(Boolean).join("<br>");
                    }
                },
                {
                    data: "created_by_user.full_name"
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        //return `<a href="#" class="text-success" onclick="ClientMissionIndex.showArchivedCandidates(${row.id}, 'accepted', this)">${jsVars.loadCandidates}</a>`;
                        let html = '';
                        html += `<div class="text-center"><a href="#" class="btn btn-success btn-small mb-2" onclick="ClientMissionIndex.showArchivedCandidates(${row.id}, 'accepted', this)">${jsVars.loadCandidates}</a></div>`;
                        html += `<div class="text-center"><a href="/app/${jsVars.languages}/client/missions/create/${row.id}" class="btn btn-primary btn-tag duplique btn-table"><i class="fa fa-fw fa-plus mr-1"></i>${jsVars.duplicateThisMission}</a></div>`;
                        return html;
                    },
                    width: "20%",
                }
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true,
            initComplete: function () {
                if (!jsVars.hasCompany) return;
                let $container = $(this.api().table().container()).find('.dataTables_filter');
                $(`
                <a href="${jsVars.createMissionUrl}" class="btn btn-primary btn-reduce">
                    <i class="fa fa-fw fa-plus mr-1"></i>
                    ${jsVars.createNewMission}
                </a>
                `).prependTo($container);
            }
        });

        window.addEventListener('message', function (message) {
            if (message.data.type === 'iframe.redirect_requested') {
                window.location = message.data.redirectTo;
            }
        });

        let $editUserModal = $('#client-candidate-show-modal');
        ExaHelpers.bindCandidateInfoModal($editUserModal);

        let $cancelMatchModal = $('#cancel-match-modal');
        let $excludeForever = $cancelMatchModal.find('.exclude-forever-container');
        $cancelMatchModal.find('[name="cancel_match_reason_id"]').on('change', function (e) {
            let $target = $(e.target);

            if ($target.val() === `${jsVars.unfitCandidateReasonId}`) {
                $excludeForever.show();
                $excludeForever.find('input').prop('disabled', false);
                $excludeForever.find('input').prop('checked', false);
                $excludeForever.find('input').removeAttr('disabled');
            } else {
                $excludeForever.hide();
                $excludeForever.find('input').prop('disabled', true);
                $excludeForever.find('input').attr('disabled', 'disabled');
            }
        })

        let swal = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        this.$missionCandidatesTable.on('click', '[type="submit"].btn-success', function (e) {
/**/
            e.preventDefault();
            let $form = $(e.target).parents('form').first();

            let missionData = "";

            try {
                missionData = JSON.parse($form.parents('.dataTables_wrapper').find('#mission-data').val());
            } catch (e) {

            }           

            if (!missionData) {
                return $form.submit();
            }

            let askedConfirmationCandidates = parseInt(missionData.askedConfirmationCandidates);
            let neededCount = parseInt(missionData.candidates_needed);

            if (askedConfirmationCandidates < neededCount) {
                return $form.submit();
            }

            swal.fire({
                title: jsVars.confirmActionTitle,
                text: jsVars.enoughCandidatesText.replace(':asked-confirmation-candidates', askedConfirmationCandidates).replace(':candidates-needed', neededCount),
                icon: "warning",
                showCancelButton: !0,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return $form.submit();
                }.bind(this)
            }).then((function (n) {
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") :
                    "cancel" === n.dismiss
            }))
/**/
        })

        this.$missionCandidatesTable.on('click', '[type="submit"].btn-danger', function (e) {
            e.preventDefault();
            let $form = $(e.target).parents('form').first();

            swal.fire({
                title: jsVars.confirmActionTitle,
                text: jsVars.deleteMatchText,
                icon: "warning",
                showCancelButton: !0,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return $form.submit();
                }.bind(this)
            }).then((function (n) {
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") :
                    "cancel" === n.dismiss
            }))
        })
    }

    showFilteredCandidates(missionId, invitationStatus, targetButton) {
        let dtUrl = jsVars.missionMatchingDatatablesAjax.replace(':mission-id', missionId);
        this.currentMissionRow = $(targetButton).parents('tr[role="row"]');
        this.returnFilter = invitationStatus;

        this.$infoContainer.find('.professions, .mission-dates, .owner').html('');
        this.$infoContainer.find('#mission-data').val('');

        if (this.$missionCandidatesTable && typeof this.$missionCandidatesTable.ajax !== "undefined") {
            this.$missionCandidatesTable.ajax.url(dtUrl).load();
        } else {
            this.$missionCandidatesTable.show();
            this.$missionCandidatesTable = this.$missionCandidatesTable.DataTable({
                ajax: {
                    url: dtUrl,
                    data: function (d) {
                        d.returnFilter = this.returnFilter;
                    }.bind(this)
                },
                order: [[1, "desc"]],
                language: {
                    url: Laravel.datatablesLanguage
                },
                columns: [
                    {
                        data: "candidate.user.gender_id",
                        render: function (data, type, row) {
                            if (typeof data !== "undefined" && typeof Laravel.genders[data] !== "undefined" && typeof row.job_title[Laravel.genders[data]] !== "undefined") {
                                return row.job_title[Laravel.genders[data]];
                            } else {
                                return row.candidate.professions;
                            }
                        }
                    },
                    {
                        data: "score",
                        render: function (data, type, row) {

                            let html_score=0;
                            if(row.score == 200){
                                html_score = "Teamer suggéré par un coacher";
                            }else{
                                html_score = row.score+"%";
                            }

                            let profilePictureUrl = row.candidate.user.profile_picture ? `${Laravel.app_url}/storage/${row.candidate.user.profile_picture}` : `${Laravel.app_url}/media/avatars/exa_avatar_placeholder.jpg`;
                            return `
                            <a href="#" class="empty-link" data-target="#client-candidate-show-modal"
                                data-remote="${jsVars.candidateShowUrl.replace(':id', row.candidate.user.id)}" data-toggle="modal">
                                <div class="js-pie-chart pie-chart" data-percent="${row.score}%" data-line-width="5" data-size="45" data-bar-color="#006CFF" data-track-color="#e9e9e9">
                                    <span>
                                        <div style="background-image: url('${profilePictureUrl}')" class="img-avatar img-avatar-thumb m-0">
                                        </div>
                                    </span>
                                </div>
                            </a>
                            <p class="">
                                <a href="#" class="empty-link" data-target="#client-candidate-show-modal"
                                    data-remote="${jsVars.candidateShowUrl.replace(':id', row.candidate.user.id)}" data-toggle="modal">
                                    <span class="subtext font-w500">${row.candidate.user.first_name} ${row.candidate.user.last_name}</span>
                                </a>
                                <br />
                                <span class="badge badge-pill badge-primary-light px-3 py-2">
                                    ${html_score}
                                </span>
                            </p>
                            `;
                        }
                    },
                    {
                        data: "candidate.user.rating_value",
                        render: function (data, type, row) {
                            let html = jsVars.noRatingYet;
                            if (row.candidate.user.rating_value) {
                                html = `${ExaHelpers.ratingToIcons(row.candidate.user.rating_value)}
                                ${row.candidate.user.rating_value} (${row.candidate.user.rating_count})`;
                            }
                            return html;
                        }.bind(this)
                    },
                    {
                        data: "client_rate",
                        render: function (data, type, row) {
                            return row.client_rate ? "CHF "+parseFloat(row.client_rate).toLocaleString('de-CH', {minimumFractionDigits: 2}) : '';
                        }
                    },
                    {
                        data: null,
                        orderable: false,
                        render: function (data, type, row) {


                            let html = '';

                            let latestResponse = row.candidate_responses && row.candidate_responses.length !== 0 ? row.candidate_responses[0] : false;
                            if (!latestResponse) {
                                return html;
                            }

                            let currType = parseInt(latestResponse.type_id);
                            let currResponse = parseInt(latestResponse.response_id);
                            let arrayStrings = [];
                            if (currType === jsVars.invitationResponse) {
                                html += `
                                <form method="POST" action="${jsVars.requestMissionConfirmationUrl.replace(':id', row.id)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn btn-small btn-block btn-success">${jsVars.requestConfirmation}</button>
                                </form>
                                <form method="POST" action="${jsVars.deleteMatchUrl.replace(':id', row.id)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn btn-small btn-block btn-danger border-s">${jsVars.deleteMatchBtn}</button>
                                </form>   `;
                            } else if (currType === jsVars.modificationResponse) {
                                if (latestResponse.response_at) {
                                    html += `
                                <form method="POST" action="${jsVars.requestMissionConfirmationUrl.replace(':id', row.id)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn btn-small btn-block btn-success">${jsVars.requestConfirmation}</button>
                                </form>
                                <form method="POST" action="${jsVars.deleteMatchUrl.replace(':id', row.id)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn btn-small btn-block btn-danger border-s">${jsVars.deleteMatchBtn}</button>
                                </form>
                                `;
                                } else {
                                    arrayStrings.push(`<b>${jsVars.responseTypes[currType]}</b>`);
                                    arrayStrings.push(`${jsVars.responses[currResponse]}`);
                                    if (latestResponse.response_at) {
                                        arrayStrings.push(`${jsVars.respondedAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}`);
                                    } else {
                                        arrayStrings.push(`${jsVars.sentAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.sent_at), jsVars.labelBetween)}. ${jsVars.waitingForResponseText}`);
                                    }

                                    html += `${arrayStrings.join(', ')}`;
                                }
                            } else if (currType === jsVars.confirmationResponse) {
                                if (latestResponse.response_at) {
                                    arrayStrings.push(`<b>${jsVars.responseTypes[currType]}</b>`);
                                    arrayStrings.push(`${jsVars.responses[currResponse]}`);
                                    if (latestResponse.response_at) {
                                        arrayStrings.push(`${jsVars.respondedAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}`);
                                    } else {
                                        arrayStrings.push(`${jsVars.sentAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.sent_at), jsVars.labelBetween)}. ${jsVars.waitingForResponseText}`);
                                    }

                                    html += `${arrayStrings.join(', ')}`;
                                } else {
                                    arrayStrings.push(`<b>${jsVars.responseTypes[currType]}</b>`);
                                    arrayStrings.push(`${jsVars.responses[currResponse]}`);
                                    if (latestResponse.response_at) {
                                        arrayStrings.push(`${jsVars.respondedAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}`);
                                    } else {
                                        arrayStrings.push(`${jsVars.sentAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.sent_at), jsVars.labelBetween)}. ${jsVars.waitingForResponseText}`);
                                    }

                                    html += `${arrayStrings.join(', ')}`;
                                }
                            }

                            if(currResponse == 4){
                                html += ` <div> <a  data-createchaturl="${jsVars.createChatUrl}" data-matchid="${row.id}" class="btn btn-small btn-outline-primary border-s btn-block open-chat-window" id="open-chat-window-${row.id}" href="javascript:void(0);">${jsVars.openChatTxt}</a></div>`;
                            }

/*
                            $.each(row.ratingsCandidate, function (_i, el) {
                                if(el.response_at === null){
                                    html +=  `<a class="btn btn-sm btn-info mt-1" target="_blank" href="${jsVars.candidateRateMissionUrl.replace(':mission-id', row.mission.id).replace(':token', el.token)}">Evaluer le teamer</a><br />`;
                                }else{
                                    html +=  `Evaluation du teamer répondue le : ${ExaHelpers.formatDateTimeWithLocale(new Date(el.response_at), jsVars.labelBetween)}<br />`;
                                }
                            });
*/




                            return `<div class="display-table">${html}</div>`;
                        }.bind(this)
                    },
                ],
                drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
                processing: true,
                serverSide: true,
                lengthChange: false,
                autoWidth: false,
                responsive: true,
                drawCallback: function (settings) {
                    this.$infoContainer.find('.professions').html(this.currentMissionRow.find('td:nth-child(1)').html());
                    this.$infoContainer.find('.mission-dates').html(this.currentMissionRow.find('td:nth-child(2)').html());
                    this.$infoContainer.find('.owner').html(this.currentMissionRow.find('td:nth-child(4)').html());
                    this.$infoContainer.find('#mission-data').val(JSON.stringify(this.$missionsTable.row(this.currentMissionRow).data()));

                    setTimeout(function () {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: this.$infoContainer.offset().top - 85 // - fixed header
                        }, 500);
                    }.bind(this), 1);

                    ExaHelpers.run(['easy-pie-chart']);

                }.bind(this),
                initComplete: function (settings, json) {
                    this.$infoContainer.detach().appendTo($('#mission-candidates-table_filter').parent().prev());
                    this.$infoContainer.show();

                    /*let rowData;
                    $.each(json, function (index, value) {
                        if (parseInt(value.id) === missionId) {
                            rowData = value;
                            return false;
                        }
                    });*/
                }.bind(this)
            });
        }
    }

    showConfirmedCandidates(missionId, invitationStatus, targetButton) {
        let dtUrl = jsVars.missionConfirmedDatatablesAjax.replace(':mission-id', missionId);

        this.currentMissionRow = $(targetButton).parents('tr[role="row"]');
        this.returnFilter = invitationStatus;

        this.$activeMissionInfoContainer.find('.professions, .mission-dates-publication, .mission-dates, .owner').html('');

        if (this.$confirmedCandidatesTable && typeof this.$confirmedCandidatesTable.ajax !== "undefined") {
            this.$confirmedCandidatesTable.ajax.url(dtUrl).load();
        } else {
            this.$confirmedCandidatesTable.show();
            this.$confirmedCandidatesTable = this.$confirmedCandidatesTable.DataTable({
                ajax: {
                    url: dtUrl,
                    data: function (d) {
                        d.returnFilter = this.returnFilter;
                    }.bind(this)
                },
                order: [[1, "asc"]],
                language: {
                    url: Laravel.datatablesLanguage
                },
                columns: [
                    {
                        data: "candidate.user.gender_id",
                        render: function (data, type, row) {
                            if (typeof data !== "undefined" && typeof Laravel.genders[data] !== "undefined" && typeof row.job_title[Laravel.genders[data]] !== "undefined") {
                                return row.job_title[Laravel.genders[data]];
                            } else {
                                return row.candidate.professions;
                            }
                        }
                    },
                    {
                        data: "candidate.user.first_name",
                        render: function (data, type, row) {
                            let profilePictureUrl = row.candidate.user.profile_picture ? `${Laravel.app_url}/storage/${row.candidate.user.profile_picture}` : `${Laravel.app_url}/media/avatars/exa_avatar_placeholder.jpg`;
                            return `
                            <a href="#" class="empty-link" data-target="#client-candidate-show-modal"
                                    data-remote="${jsVars.candidateShowUrl.replace(':id', row.candidate.user.id)}" data-toggle="modal">
                                <div class="js-pie-chart pie-chart" data-percent="${row.score}%" data-line-width="5" data-size="45" data-bar-color="#006CFF" data-track-color="#e9e9e9">
                                    <span><div style="background-image: url('${profilePictureUrl}')" class="img-avatar img-avatar-thumb m-0"></div></span>
                                </div>
                            </a>
                            <p>
                                <a href="#" class="empty-link" data-target="#client-candidate-show-modal"
                                    data-remote="${jsVars.candidateShowUrl.replace(':id', row.candidate.user.id)}" data-toggle="modal">
                                    <span class="subtext font-w500">${row.candidate.user.first_name} ${row.candidate.user.last_name}</span>
                                </a>
                                <br />
                                <span class="badge badge-pill badge-primary-light px-3 py-2">
                                    ${row.score}%
                                </span>
                            </p>
                            `;
                        }
                    },
                    {
                        data: "candidate.user.rating_value",
                        render: function (data, type, row) {
                            let html = jsVars.noRatingYet;
                            if (row.candidate.user.rating_value) {
                                html = `${ExaHelpers.ratingToIcons(row.candidate.user.rating_value)}
                                ${row.candidate.user.rating_value} (${row.candidate.user.rating_count})`;
                            }
                            return html;
                        }.bind(this)
                    },
                    {
                        data: "client_rate",
                        render: function (data, type, row) {
                            return row.client_rate ? "CHF "+parseFloat(row.client_rate).toLocaleString('de-CH', {minimumFractionDigits: 2}) : '';
                        }
                    },
                    {
                        data: null,
                        orderable: false,
                        render: function (data, type, row) {
                            let html = '';

                            let latestResponse = row.candidate_responses && row.candidate_responses.length !== 0 ? row.candidate_responses[0] : false;
                            if (!latestResponse) {
                                return html;
                            }

                            let currType = parseInt(latestResponse.type_id);
                            if (!row.canceled_at) {
                                html += `<button onclick="ClientMissionIndex.cancelMatchSetUrl(this)" class="btn btn-small btn-outline-danger btn-block border-s"
                                data-toggle="modal" data-target="#cancel-match-modal">${jsVars.cancelText}</button><br>`;
                            } else {
                                html += `${jsVars.canceledAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(row.canceled_at), jsVars.labelBetween)}`;

                                if (row.cancel_match_reason_id && row.cancel_match_reason_id !== "") {
                                    let cancelMatchDate = new Date(row.cancel_match_end_date);
                                    cancelMatchDate = ExaHelpers.isValidDate(cancelMatchDate) ? ExaHelpers.formatDateWithLocale(cancelMatchDate) : '';

                                    html += `<br>${jsVars.cancelMatchReasons[row.cancel_match_reason_id]}<br>
                                    ${jsVars.cancelMatchDateText}: ${cancelMatchDate}<br>
                                    <span class="cancel-match-description" data-toggle="tooltip" data-placement="bottom" title="${row.cancel_match_description}!">
                                    ${row.cancel_match_description}</span>`;
                                }
                                currType = -1;
                            }

                            if (currType === jsVars.invitationResponse) {
                                html += `
                                <form method="POST" action="${jsVars.requestMissionConfirmationUrl.replace(':id', row.id)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="btn btn-small btn-block btn-success">${jsVars.requestConfirmation}</button>
                                </form>`;
                            } else if (currType === jsVars.modificationResponse) {
                                if (latestResponse.response_at) {
                                    html += `
                                <form method="POST" action="${jsVars.requestMissionConfirmationUrl.replace(':id', row.id)}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <button type="submit" class="bt btn-small btn-block btn-success">${jsVars.requestConfirmation}</button>
                                </form>`;
                                } else {
                                    html += ` ${jsVars.sentAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.sent_at), jsVars.labelBetween)}`;
                                }
                            } else if (currType === jsVars.confirmationResponse) {
                                if (latestResponse.response_at) {
                                    html += `${jsVars.respondedAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.response_at), jsVars.labelBetween)}`;
                                } else {
                                    html += ` ${jsVars.sentAt} ${ExaHelpers.formatDateTimeWithLocale(new Date(latestResponse.sent_at), jsVars.labelBetween)}`;
                                }
                            }
                            return html;
                        }.bind(this)
                    },
                ],
                drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
                processing: true,
                serverSide: true,
                lengthChange: false,
                autoWidth: false,
                responsive: true,
                drawCallback: function (settings) {
                    this.$activeMissionInfoContainer.find('.professions').html(this.currentMissionRow.find('td:nth-child(1)').html());
                    this.$activeMissionInfoContainer.find('.mission-dates-publication').html(this.currentMissionRow.find('td:nth-child(2)').html());
                    this.$activeMissionInfoContainer.find('.mission-dates').html(this.currentMissionRow.find('td:nth-child(3)').html());
                    this.$activeMissionInfoContainer.find('.owner').html(this.currentMissionRow.find('td:nth-child(4)').html());

                    setTimeout(function () {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: this.$activeMissionInfoContainer.offset().top - 85 // - fixed header
                        }, 500);
                    }.bind(this), 1);

                    ExaHelpers.run(['easy-pie-chart', 'core-bootstrap-tooltip']);

                }.bind(this),
                initComplete: function (settings, json) {
                    this.$activeMissionInfoContainer.detach().appendTo($('#confirmed-candidates-table_filter').parent().prev());
                    this.$activeMissionInfoContainer.show();
                }.bind(this)
            });
        }
    }

    showArchivedCandidates(missionId, invitationStatus, targetButton) {
        let dtUrl = jsVars.missionArchivedCandidatesDatatablesAjax.replace(':mission-id', missionId);


        this.currentMissionRow = $(targetButton).parents('tr[role="row"]');
        this.returnFilter = invitationStatus;

        this.$archivedMissionInfoContainer.find('.professions, .mission-dates, .owner').html('');

        if (this.$archivedCandidatesTable && typeof this.$archivedCandidatesTable.ajax !== "undefined") {
            this.$archivedCandidatesTable.ajax.url(dtUrl).load();
        } else {
            this.$archivedCandidatesTable.show();
            this.$archivedCandidatesTable = this.$archivedCandidatesTable.DataTable({
                ajax: {
                    url: dtUrl,
                    data: function (d) {
                        d.returnFilter = this.returnFilter;
                    }.bind(this)
                },
                order: [[1, "desc"]],
                language: {
                    url: Laravel.datatablesLanguage
                },
                columns: [
                    {
                        data: "candidate.user.gender_id",
                        render: function (data, type, row) {
                            if (typeof data !== "undefined" && typeof Laravel.genders[data] !== "undefined" && typeof row.job_title[Laravel.genders[data]] !== "undefined") {
                                return row.job_title[Laravel.genders[data]];
                            } else {
                                return row.candidate.professions;
                            }
                        }
                    },
                    {
                        data: "score",
                        render: function (data, type, row) {
                            let profilePictureUrl = row.candidate.user.profile_picture ? `${Laravel.app_url}/storage/${row.candidate.user.profile_picture}` : `${Laravel.app_url}/media/avatars/exa_avatar_placeholder.jpg`;
                            return `
                            <a href="#" class="empty-link" data-target="#client-candidate-show-modal"
                                    data-remote="${jsVars.candidateShowUrl.replace(':id', row.candidate.user.id)}" data-toggle="modal">
                                <div class="js-pie-chart pie-chart" data-percent="${row.score}%" data-line-width="5" data-size="45" data-bar-color="#006CFF" data-track-color="#e9e9e9">
                                    <span><div style="background-image: url('${profilePictureUrl}')" class="img-avatar img-avatar-thumb m-0"></div></span>
                                </div>
                            </a>
                            <p>
                                <a href="#" class="empty-link" data-target="#client-candidate-show-modal"
                                    data-remote="${jsVars.candidateShowUrl.replace(':id', row.candidate.user.id)}" data-toggle="modal">
                                    <span class="subtext font-w500">${row.candidate.user.first_name} ${row.candidate.user.last_name}</span>
                                </a>
                                <br />
                                <span class="badge badge-pill badge-primary-light px-3 py-2">
                                    ${row.score}%
                                </span>
                            </p>
                            `;
                        }
                    },
                    {
                        data: "candidate.user.rating_value",
                        render: function (data, type, row) {
                            let html = jsVars.noRatingYet;
                            if (row.candidate.user.rating_value) {
                                html = `${ExaHelpers.ratingToIcons(row.candidate.user.rating_value)}
                                ${row.candidate.user.rating_value} (${row.candidate.user.rating_count})`;
                            }
                            return html;
                        }.bind(this)
                    },
                    {
                        data: "client_rate",
                        render: function (data, type, row) {
                            return row.client_rate ? "CHF "+parseFloat(row.client_rate).toLocaleString('de-CH', {minimumFractionDigits: 2}) : '';
                        }
                    },
                    {
                        data: null,
                        orderable: false,
                        render: function (data, type, row) {
                            let ratingOfMe, ratingILeft;
                            let html = '';

                            $.each(row.mission.ratings, function (_i, rating) {
                                if (parseInt(rating.user_id) === jsVars.myUserId) {
                                    if (rating.total) {
                                        ratingOfMe = `${jsVars.ratingOfMe}: ${ExaHelpers.ratingToIcons(rating.total)}`;
                                    }
                                } else {
                                    if (rating && !rating.total) {
                                        ratingILeft = `
                                     <a href="#" class="empty-link btn btn-small btn-primary btn-block" data-target="#client-candidate-show-modal"
                                        data-remote="${jsVars.rateUserUrl.replace(':id', rating.mission_id).replace(':token', rating.token)}"
                                        data-toggle="modal">
                                        ${jsVars.rateCandidate}
                                    </a>`;
                                    } else if (rating && rating.total) {
                                        ratingILeft = `${jsVars.rating}: ${ExaHelpers.ratingToIcons(rating.total)}`;
                                    }
                                }
                            })

                            html += `<div class="rating-pair-container">${[ratingOfMe, ratingILeft].filter(Boolean).join("<br>")}</div>`;

                            if (row.cancel_match_reason_id && row.cancel_match_reason_id !== "") {
                                let cancelMatchDate = new Date(row.cancel_match_end_date);
                                cancelMatchDate = ExaHelpers.isValidDate(cancelMatchDate) ? ExaHelpers.formatDateWithLocale(cancelMatchDate) : '';

                                html += `<br>[${jsVars.canceledText}] ${jsVars.cancelMatchReasons[row.cancel_match_reason_id]}<br>
                                    ${jsVars.cancelMatchDateText}: ${cancelMatchDate}<br>
                                    <span class="cancel-match-description" data-toggle="tooltip" data-placement="bottom" title="${row.cancel_match_description}!">
                                    ${row.cancel_match_description}</span>`;
                            }

                            if(row.candidate.user.code_affiliation != null){
                                if(row.candidate.user.code_affiliation.includes(jsVars.code_affiliation_company) ){
                                   html += `
                                  <form method="POST" action="${jsVars.desaffiliate_url}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <input type="hidden" name="code" value="${jsVars.code_affiliation_company}">
                                    <input type="hidden" name="user_id" value="${row.candidate.user.id}">
                                    <button type="submit" class="btn btn-small btn-outline-danger border-s text-dark btn-block mt-3">${jsVars.removeTheAffiliation}</button>
                                </form>`

                                   // html += `<a href="desafiliate/${row.candidate.user.id}/${jsVars.code_affiliation_company}" class="btn btn-sm btn-warning mt-3">${jsVars.removeTheAffiliation}</a>`;
                                }else{
                                    html += `
                                    <form method="POST" action="${jsVars.affiliate_url}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <input type="hidden" name="code" value="${jsVars.code_affiliation_company}">
                                    <input type="hidden" name="user_id" value="${row.candidate.user.id}">
                                    <button type="submit" class="btn btn-small btn-block btn-success mt-3">${jsVars.affiliateThisTeamer}</button>
                                </form>`

                                   // html += `<a href="affiliate/${row.candidate.user.id}/${jsVars.code_affiliation_company}" class="btn btn-sm btn-success mt-3">${jsVars.affiliateThisTeamer}</a>`;
                                }
                            }else{
                                html += `
                                <form method="POST" action="${jsVars.affiliate_url}">
                                    <input type="hidden" name="_token" value="${Laravel.csrfToken}">
                                    <input type="hidden" name="code" value="${jsVars.code_affiliation_company}">
                                    <input type="hidden" name="user_id" value="${row.candidate.user.id}">
                                    <button type="submit" class="btn btn-small btn-block btn-success mt-3">${jsVars.affiliateThisTeamer}</button>
                                </form>`

                               //  html += `<a href="affiliate//${row.candidate.user.id}/${jsVars.code_affiliation_company}" class="btn btn-sm btn-success mt-3">${jsVars.affiliateThisTeamer}</a>`;
                            }

                            return html;
                        }.bind(this)
                    },
                ],
                drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
processing: true,
                serverSide: true,
                lengthChange: false,
                autoWidth: false,
                responsive: true,
                drawCallback: function (settings) {
                    this.$archivedMissionInfoContainer.find('.mission-titre').html(this.currentMissionRow.find('td:nth-child(1)').html());
                    this.$archivedMissionInfoContainer.find('.professions').html(this.currentMissionRow.find('td:nth-child(2)').html());
                    this.$archivedMissionInfoContainer.find('.mission-dates-publication').html(this.currentMissionRow.find('td:nth-child(3)').html());
                    this.$archivedMissionInfoContainer.find('.mission-dates').html(this.currentMissionRow.find('td:nth-child(4)').html());
                    this.$archivedMissionInfoContainer.find('.owner').html(this.currentMissionRow.find('td:nth-child(5)').html());

                    
                      //  console.log(this.$archivedMissionInfoContainer);
                    
                    setTimeout(function () {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: this.$archivedMissionInfoContainer.offset().top - 85 // - fixed header
                        }, 500);
                    }.bind(this), 1);

                    ExaHelpers.run(['easy-pie-chart', 'core-bootstrap-tooltip']);

                }.bind(this),
                initComplete: function (settings, json) {
                    this.$archivedMissionInfoContainer.detach().appendTo($('#archived-candidates-table_filter').parent().prev());
                    this.$archivedMissionInfoContainer.show();
                }.bind(this)
            });
        }
    }

    cancelMatchSetUrl(targetButton) {
        let $targetButton = $(targetButton);
        let $form = $($targetButton.data('target')).find('form');
        let matchData = $targetButton.parents('table').DataTable().row($targetButton.parents('tr')).data();
        let endDate = new Date(matchData.earliest_stopping_date);
        let $infoText = $form.find('.modified-end-date-container .info-text');
        let $endDateInput = $form.find('[name="cancel_match_end_date"]');

        $form.prop('action', jsVars.cancelMatchUrl.replace(':match-id', matchData.id));
        $form.find('[name="exclude_candidate_id"]').val(matchData.candidate_id);
        $form.find('[name="exclude_forever"]').prop('checked', false);
        $form.find('.exclude-forever-container').hide();

        $infoText.html(`
            ${jsVars.cancelInfo1Text.replace(':earliest-end-date', ExaHelpers.formatDateWithLocale(endDate))}
            ${jsVars.cancelInfo2Text}
        `);

        if ($endDateInput.length !== 0) {
            $endDateInput[0]._flatpickr.set('minDate', flatpickr.formatDate(endDate, 'Y-m-d'));
        }
    }

    initValidation() {
        $('#cancel-match-modal form').validate({
            ignore: "[contenteditable='true']:not([name])",
            rules: {
                'cancel_match_reason_id': {
                    required: true,
                },
                'cancel_match_description': {
                    required: true,
                },
            },
        });
    }
}

